


























import { HomeSummary } from '@/types';
import { getUserData } from '@/api';
import { setRememberMe, getRememberMe, buyerNameGenerator, getCoBuyers, getBuyerNameString, standardCasing, filterJobsbyId } from '@/util';
import Vue from 'vue';
import { mapGetters } from 'vuex'
import { JobStatus, Routes } from '@/constants';

export default Vue.extend({
  name: 'SelectHome',
  data () {
    return {
      jobId: '' as string | null,
      homeDetail: [] as HomeSummary[]
    };
  },
  computed: {
    ...mapGetters([
      'signedIn',
      'user'
    ])
  },
  async beforeMount () {
    const data = await getUserData();
    this.homeDetail = data.jobs;
    if (!this.homeDetail || !this.homeDetail.length) {
      this.$router.push({ name: Routes.SIGNIN });
    }
    if (this.homeDetail.length < 2) {
      setRememberMe(this.homeDetail[0].jobNumber);
      this.$router.push({ name: Routes.DASHBOARD });
    }
    this.jobId = getRememberMe();
    !this.homeDetail.some((data: any) => data.jobNumber === this.jobId) && setRememberMe('');
  },
  methods: {
    handleImageError (event: Event) {
      (event.target as HTMLImageElement).src = require('@/assets/images/defaultHome.png')
    },
    selectHome (jobId: string) {
      setRememberMe(jobId);
      this.$router.push({ name: Routes.DASHBOARD });
    },
    fetchSelectedHome () {
      this.jobId = getRememberMe();
    },
    getBuyerName (jobId: string) {
      const nameString = getBuyerNameString(jobId);
      return standardCasing(nameString);
    },
    coBuyerNames (jobId: string) {
      const coBuyers = getCoBuyers(jobId);
      return standardCasing(buyerNameGenerator(coBuyers));
    },
    preClose (jobId: string): boolean {
      return filterJobsbyId(jobId).status === JobStatus.PRE_CLOSE;
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.matched.some(record => record.meta.requireJobId) && !getRememberMe()) {
      const selectHomeDiv = this.$refs.highlight as HTMLElement;
      selectHomeDiv.classList.add('borderRed');
      setTimeout(() => {
        selectHomeDiv.classList.remove('borderRed');
      }, 1000);
    }
    next();
  }
});
